export default __webpack_public_path__ + "static/media/requerimento.4f57a140.jpg";